import {VariantState} from '@/product/types';

/**
 * Returns the first variant that matches the specified option name and value.
 * If no variant is found, returns null.
 *
 * @param variants - An array of variant states.
 * @param optionName - The name of the option to match.
 * @param optionValue - The value of the option to match.
 * @returns The variant that matches the specified option name and value, or null if no match is found.
 */
export function getVariantByOption(
  variants: VariantState[],
  optionName: string,
  optionValue: string
): VariantState | null {
  return (
    variants.find((variant) => {
      return (
        variant.selectedOptions.find(
          (option) => option.name === optionName && option.value === optionValue
        ) !== undefined
      );
    }) ?? null
  );
}
